import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FiSearch, FiEye, FiEdit, FiTrash2, FiPlus, FiMinus } from 'react-icons/fi'; // Using react-icons library
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmAlert } from 'react-confirm-alert'; // Import for confirmation dialog
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import the confirmation dialog CSS
import { FiChevronDown, FiChevronUp, } from 'react-icons/fi';
import axios from 'axios';
import { FiX } from "react-icons/fi";


const Container = styled.div`
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-family: 'Segoe UI', 'Semibold';
  color:#293495;

`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 8px;
  padding: 7px;
  width: 248px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 16px;
  padding: 5px;
  flex: 1; /* Ensure input takes up remaining space */
`;

const SearchIcon = styled(FiSearch)`
  margin-right: 10px;
  color: #000; /* Adjust color as needed */
`;


const Card = styled.div`
  background-color: #f5f5f5;
  box-shadow: 0px 5px 10px #00000038;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center; /* Center vertically */
  margin-bottom: 20px;
  width: 100%;
  gap: 10px;  // Add this line to create space between items

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormItem = styled.div`
  flex: 1 1 300px; /* Flex-grow, flex-shrink, and minimum width */
`;

const Label = styled.label`
  display: block;
  font-family: 'Segoe UI', 'Semibold';
  color: #000;
  margin-bottom: 5px;
  font-weight: 600;
    &::after {
    content: '*';
    color: red;
    margin-left: 5px;
  }
`;

const Asterisk = styled.span`
  color: red;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px 0;
  border: none;
  border-bottom: 1px solid #2B3497;
  font-family: 'Segoe UI', 'Regular';
  background: transparent;
  &:focus {
    outline: none;
    border-bottom: 2px solid #2B3497;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  @media (max-width: 768px) {
    justify-content: center;
    margin-top: 20px;
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 16px;
  font-family: 'Segoe UI', 'Semibold';
  border-radius: 27px;
  opacity: 1;
  color: #fff;
  margin-right: 30px; // Space to the right of the button



&.add-location {
  background-color: #293495;
  white-space: nowrap; /* Prevents text from wrapping */

}
    &.reset {
    background-color: red;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  &.submit {
    background-color: #3d46b4;
    border-radius: 12px;
    box-shadow: 0px 10px 20px #2b349752;
  }

  & > svg {
    margin-left: 8px;
  }`
  ;


const TableContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: linear-gradient(to right, #e6e6e6, #f2f2f2, #f5f5f5, #f3f3f3, #e9e9e9);
  box-shadow: 0px 10px 20px #0000001a;
  border-radius: 10px;
`;

const TableHeader = styled.th`
  background-color: #e6e6e6;
  color: #000;
  padding: 10px;
  text-align: left;
      cursor: pointer;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f5f5f5;
  }

  &:hover {
    background-color: #d9d9d9;
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: left;
`;

const IconWrapper = styled.span`
  cursor: pointer;
  color: #2B3497;
  margin: 0 5px;
`;
const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  gap: 10px;
`;

const PaginationButton = styled.button`
  background-color: #3d46b4;
  color: #fff;
  border: none;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s ease;
  &:hover {
    background-color: #293495;
  }
  &:focus {
    outline: none;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const DropdownSelect = styled.select`
  background-color: #fff;
  color: #293495;
  border: 1px solid #3d46b4;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
    border-color: #293495;
  }
`;
const ZeroStateMessage = styled.div`
  margin-top: 20px;
  font-size: 18px;
  color: #666;
  text-align: center;
`;
const Dropdown = styled.select`
  border: none;
  border-bottom: 1px solid #2B3497;
  padding: 8px 0;
  background: transparent;
  font-family: 'Segoe UI', Regular;
  outline: none; /* Remove default focus outline */
  margin-right: 20px; // Space to the right of the dropdown
  flex: 1; // Makes the dropdown take up more space
`;
const Popup = styled.div`
  position: fixed;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
   background: #fff;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  opacity: 1;
  z-index: 1000;
  width: 500px;
  height: auto; /* Use auto height to fit content */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Push content and buttons to the top/bottom */
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; /* Align buttons to the right */
  margin-top: 20px; /* Add some space between content and buttons */
`;

const PopupButton = styled.button`
  background-color: #2B3397;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  box-shadow: 0px 10px 20px #2B349754;
  opacity: 1;
  cursor: pointer;
  margin-left: 10px; /* Add space between buttons */
`;

const PopupText = styled.p`
  font-size: 18px;
  color: #2B3497;
  margin-bottom: 20px;
`;
const LabelValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;



const Value = styled.span`
  font-size: 16px;
  color: #000;
  width: 55%; /* Control value width */
  text-align: right; /* Ensure value is aligned to the right */
`;


const BadgeTemplatePage = () => {
  const [showInput, setShowInput] = useState(false);

  const [formValues, setFormValues] = useState({
    employeeRole: '',
    employeeName: '',
    tempId: ''
  });

  const [tableData, setTableData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPagination, setShowPagination] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [roles, setRoles] = useState([]);
  const [empNames, setEmpName] = useState([]);
  const [tempNames, setTempName] = useState([]);

  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');

  const rowsPerPage = 7;
  // Fetch Employee Role Map data from API
  const fetchEmployeeRoleMapData = async () => {
    try {
      const response = await axios.get('/BadgeTemplateMap/GetmappedBadgeTemplate');
      setTableData(response.data);
    } catch (error) {
      console.error('Error fetching Employee Role Map data:', error);
    }
  };
  const sortData = (data, column, direction) => {
    const sortedData = [...data].sort((a, b) => {
      if (direction === 'asc') {
        return a[column] > b[column] ? 1 : -1;
      } else {
        return a[column] < b[column] ? 1 : -1;
      }
    });
    return sortedData;
  };

  const handleSort = (column) => {
    const direction = sortColumn === column && sortDirection === 'asc' ? 'desc' : 'asc';
    setSortColumn(column);
    setSortDirection(direction);
    const sortedData = sortData(tableData, column, direction);
    setTableData(sortedData);
  };

  // Call fetchEmployeeRoleMapData once on component mount
  useEffect(() => {
    fetchEmployeeRoleMapData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [editRowId, setEditRowId] = useState(null);

  const [isPopupVisibleCreate, setIsPopupVisibleCreate] = useState(false);

  const handleAddLocationClick = () => {
    setIsEditMode(false);
    setFormValues({ employeeRole: "", employeeName: "", tempId: "" });
    setIsPopupVisibleCreate(true);
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditRowId(row.id);

    setFormValues({
      employeeRole: row.entityID,
      employeeName: row.visitorTypeID,
      tempId: row.badgeTemplateID,
    });

    setIsPopupVisibleCreate(true);
  };

  const handleSubmit = async () => {
    if (formValues.employeeRole && formValues.employeeName && formValues.tempId) {
      try {
        const currentDate = new Date().toISOString();

        // get selected entity/visitor/template names
        const selectedEntity = roles.find((r) => r.id === parseInt(formValues.employeeRole));
        const selectedVisitor = empNames.find((v) => v.id === parseInt(formValues.employeeName));
        const selectedTemplate = tempNames.find((t) => t.id === parseInt(formValues.tempId));

        const payload = {
          id: isEditMode ? editRowId : 0, // id only required in edit mode
          entityID: formValues.employeeRole,
          visitorTypeID: formValues.employeeName,
          badgeTemplateID: formValues.tempId,
          entityName: selectedEntity?.entityName || "",
          visitorTypeName: selectedVisitor?.visitorTypeDesc || "",
          badgeTemplateName: selectedTemplate?.name || "",
          isActive: true,
          createdBy: "system",
          createdOn: currentDate,
          modifiedBy: "system",
          modifiedOn: currentDate,
        };

        let response;

        if (isEditMode) {
          // 🔹 Call EDIT API
          response = await axios.post("/BadgeTemplateMap/EditMappedTemplate", payload);

          if (response.status === 200) {
            toast.success("Mapping updated successfully!");
          }
        } else {
          // 🔹 Call CREATE API
          response = await axios.post("/BadgeTemplateMap/CreateBadgeTemplateMapping", payload);

          if (response.data === "Detail already exists") {
            toast.error("Detail already exists. Please enter different values.");
            handleReset();
            return;
          }

          if (response.status === 200) {
            toast.success("Mapping created successfully!");
          }
        }

        // Refresh table
        fetchEmployeeRoleMapData();

        // Reset form + close popup
        setFormValues({ employeeRole: "", employeeName: "", tempId: "" });
        setIsPopupVisibleCreate(false);
        setIsEditMode(false);
      } catch (error) {
        console.error("Error in submit:", error);
        toast.error("Error occurred while saving mapping.");
      }
    } else {
      toast.warning("Please fill out all required fields.");
    }
  };


  const handleDelete = (id) => {
    confirmAlert({
      title: <span style={{ color: '#dc3545' }}>Warning</span>,
      message: 'Are you sure you want to delete this row?',
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            try {
              // Get current date in ISO string format
              const currentDate = new Date().toISOString();

              // Prepare payload
              const payload = {
                id: id,
              };

              // Call the API using POST instead of DELETE
              const response = await axios.post(
                `/BadgeTemplateMap/DeleteMappedTemplate/${id}`,
              );

              if (response.status === 200) {
                toast.success('Deleted successfully');

                // Remove row from tableData
                fetchEmployeeRoleMapData();
              } else {
                toast.error('Failed to delete the item');
              }
            } catch (error) {
              console.error('Error deleting data:', error);
              toast.error('There was an error deleting the item');
            }
          },
        },
        {
          label: 'No',
          onClick: () => {
            toast.info('Delete cancelled');
          },
        },
      ],
    });
  };


  const handleReset = () => {
    setFormValues({
      employeeName: '',
      employeeRole: '',
      tempId: ""
    });
    setCurrentPage(1); // Reset pagination to the first page

  };


  const filteredData = tableData.filter((row) =>
    row.entityName && row.entityName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.visitorTypeName && row.visitorTypeName.toLowerCase().includes(searchQuery.toLowerCase()) ||
    row.badgeTemplateName && row.badgeTemplateName.toLowerCase().includes(searchQuery.toLowerCase())

  );

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (event) => {
    setCurrentPage(Number(event.target.value));
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalPageNumbers = Math.min(totalPages, 10); // Show up to 10 page numbers

    let startPage = Math.max(currentPage - 5, 1);
    let endPage = Math.min(startPage + totalPageNumbers - 1, totalPages);

    // Adjust startPage if endPage exceeds totalPages
    if (endPage === totalPages) {
      startPage = Math.max(totalPages - totalPageNumbers + 1, 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <PaginationButton
          key={i}
          className={currentPage === i ? 'active' : ''}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </PaginationButton>
      );
    }

    return pageNumbers;
  };
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const roleNameResponse = await axios.get('/Entity/GetEntity');
        setRoles(roleNameResponse.data);

        const employeeNameResponse = await axios.get('/VisitorType');
        setEmpName(employeeNameResponse.data);
        const tempResponse = await axios.get('/BadgeTemplateMap/GetBadgeTemplate');
        setTempName(tempResponse.data);


      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };

    fetchDropdownData();
  }, []);

  const [isExpanded, setIsExpanded] = useState(true);
  const toggleExpandCollapse = () => {
    setIsExpanded(!isExpanded);
  };


  return (
    <Container>
      <Header>
        <Heading>Badge Template Mapping</Heading>
        <SearchBox>
          <SearchIcon size={20} />
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </SearchBox>
      </Header>
      <Card>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Button className="add-location" onClick={handleAddLocationClick}>
            Add Template  <FiPlus size={20} />
          </Button>
          {/* {showInput && (

            <FormItem>
              <Label>
                Employee Role<Asterisk>*</Asterisk>
              </Label>
              <Dropdown
                name="employeeRole"
                value={formValues.employeeRole}
                onChange={handleInputChange}
                style={{ fontSize: "12px" }}

              >
                <option value="">Select Employee Role</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.roleId}>
                    {role.txtRoles}
                  </option>
                ))}
              </Dropdown>
            </FormItem>

          )}
          {showInput && (

            <FormItem>
              <Label>
                Employee Name<Asterisk>*</Asterisk>
              </Label>
              <Dropdown
                name="employeeName"
                value={formValues.employeeName}
                onChange={handleInputChange}
                style={{ fontSize: "12px" }}

              >
                <option value="">Select Employee Name</option>
                {empNames.map((empName) => (
                  <option key={empName.id} value={empName.id}>
                    {empName.employeeName}
                  </option>
                ))}
              </Dropdown>
            </FormItem>

          )} */}
        </div>

        {/* <ButtonGroup>
          <Button className="reset" onClick={handleReset}>
            Reset
          </Button>
          <Button className="submit" onClick={handleSubmit}>
            Submit
          </Button>
        </ButtonGroup> */}
      </Card>
      {filteredData.length === 0 ? (
        <ZeroStateMessage>No data available</ZeroStateMessage>
      ) : (
        <TableContainer>
          <StyledTable>
            <thead>
              <tr>
                <TableHeader colSpan={'4'} style={{ backgroundColor: "rgb(24, 62, 159)", color: "#fff" }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ textAlign: 'center', flex: '1', color: "#fff" }}>BadgeTemplateMapping Details</span>
                    <IconWrapper onClick={toggleExpandCollapse} style={{ cursor: 'pointer', color: "#fff" }}>
                      {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
                    </IconWrapper>
                  </div>
                </TableHeader>

              </tr>
            </thead>
            {isExpanded && (
              <>
                <thead>
                  <tr>
                    <TableHeader onClick={() => handleSort('entityName')}>Entity Name{sortColumn === 'entityName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('visitorTypeName')}>Visitor Type{sortColumn === 'visitorTypeName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>
                    <TableHeader onClick={() => handleSort('badgeTemplateName')}>Template Type{sortColumn === 'badgeTemplateName' && (sortDirection === 'asc' ? '↑' : '↓')}</TableHeader>

                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {currentRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.entityName}</TableCell>
                      <TableCell>{row.visitorTypeName}</TableCell>
                      <TableCell>{row.badgeTemplateName}</TableCell>

                      <TableCell>
                        <IconWrapper onClick={() => handleEdit(row)}>
                          <FiEdit />
                        </IconWrapper>
                        <IconWrapper onClick={() => handleDelete(row.id, index)}>
                          <FiTrash2 />
                        </IconWrapper>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </>
            )}
          </StyledTable>
          {isExpanded && (
            <>
              <PaginationContainer>
                <PaginationButton onClick={handlePrevPage} disabled={currentPage === 1}>
                  Previous
                </PaginationButton>

                <DropdownSelect value={currentPage} onChange={handlePageChange}>
                  {Array.from({ length: totalPages }, (_, i) => (
                    <option key={i + 1} value={i + 1}>
                      Page {i + 1}
                    </option>
                  ))}
                </DropdownSelect>

                <PaginationButton onClick={handleNextPage} disabled={currentPage === totalPages}>
                  Next
                </PaginationButton>
              </PaginationContainer>
            </>
          )}
        </TableContainer>
      )}

      {isPopupVisibleCreate && (
        <Popup>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h3 style={{ margin: 0, color: '#293495' }}>        {isEditMode ? "Edit Template" : "Add Template"}
            </h3>
            <FiX
              style={{ cursor: 'pointer' }}
              size={20}
              onClick={() => setIsPopupVisibleCreate(false)}
            />
          </div>
          <LabelValueContainer>
            <Label>Entity Type:</Label>
            <Value>
              <Dropdown
                name="employeeRole"
                value={formValues.employeeRole}
                onChange={handleInputChange}
                style={{ fontSize: "12px", width: '200px' }}

              >
                <option value="">Select Entity Type</option>
                {roles.map((role) => (
                  <option key={role.id} value={role.id}>
                    {role.entityName}
                  </option>
                ))}
              </Dropdown>
            </Value>
          </LabelValueContainer>
          <LabelValueContainer>
            <Label>Visitor Type:</Label>
            <Value>
              <Dropdown
                name="employeeName"
                value={formValues.employeeName}
                onChange={handleInputChange}
                style={{ fontSize: "12px", width: '200px' }}

              >
                <option value="">Select Visitor Type</option>
                {empNames.map((empName) => (
                  <option key={empName.id} value={empName.id}>
                    {empName.visitorTypeDesc}
                  </option>
                ))}
              </Dropdown>
            </Value>
          </LabelValueContainer>
          <LabelValueContainer>
            <Label>Template Type:</Label>
            <Value>
              <Dropdown
                name="tempId"
                value={formValues.tempId}
                onChange={handleInputChange}
                style={{ fontSize: "12px", width: '200px' }}

              >
                <option value="">Select Template</option>
                {tempNames.map((tempNames) => (
                  <option key={tempNames.id} value={tempNames.id}>
                    {tempNames.name}
                  </option>
                ))}
              </Dropdown>
            </Value>
          </LabelValueContainer>
          <ButtonContainer>
            <PopupButton onClick={handleReset} style={{ backgroundColor: 'red' }}>Reset</PopupButton>
            <PopupButton onClick={handleSubmit}>        {isEditMode ? "Update" : "Submit"}
            </PopupButton>
          </ButtonContainer>
          {/* Show loader when loading */}
        </Popup>
      )}
      <ToastContainer />
    </Container>
  );
};

export default BadgeTemplatePage;
